module.exports = __webpack_public_path__ + "images/emoji/chestnut.3a5034816fa49247ecad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/chestnut.png
// module id = 2K9V
// module chunks = 1